import api from '@/components/mixins/baseApi';
import { queueKey, QUEUE_BATCH } from '@/components/scanner/config';

export default {
  mixins: [api],
  methods: {
    // @param {Array} packet — [{ code, ts }, ...]. Оба пути, прямой и
    // отложенный, шлют массив: прежняя версия отправляла очередь строкой JSON,
    // и на один эндпоинт уходило два разных тела.
    //
    // ts — момент сканирования, его сервер и записывает. Прошедшее время
    // принимается без оговорок: отсканировано вчера — значит вчера.
    sendScannerCode(packet) {
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/scanner`,
        data: packet,
      });
    },

    getScannerStatistic() {
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/scanner`,
      });
    },

    getZipLinks() {
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/scanner/get-zip-link`,
      }).then((data) => ({
        link: data.results?.link || null,
        password: data.results?.password || null,
        message: data.results?.message || null,
      }));
    },

    // Отправка накопленной очереди текущего мероприятия.
    //
    // Имя и контракт сохранены: метод вызывает быстрый вход по ссылке
    // (AuthFastView.vue) до подмены мероприятия и решает по опустевшей очереди,
    // пускать человека дальше или нет. Поэтому ошибки гасятся внутри, а
    // результат виден по состоянию хранилища — см. docs/fast-login.md.
    sendScannerListCode() {
      const exhId = this.$store.getters.getExhId;
      if (!exhId || this.$store.getters.isScanerSending) return Promise.resolve({});

      const key = queueKey(exhId);
      const queue = this.readQueue(key);
      if (!queue.length) return Promise.resolve({});

      this.$store.commit('updScanerSending', true);
      return this.sendQueueBatch(key, queue)
        .catch((error) => error)
        .finally(() => {
          this.$store.commit('updScanerSending', false);
        });
    },

    // Пачками по QUEUE_BATCH, по одной за раз. Следующая уходит только после
    // подтверждения предыдущей: на слабой связи короткий запрос доходит вернее,
    // а неподтверждённая пачка остаётся в очереди целиком.
    sendQueueBatch(key, queue) {
      const batch = queue.slice(0, QUEUE_BATCH);
      return this.sendScannerCode(batch)
        .then((data) => {
          if (!this.isBatchAccepted(data, batch.length)) return data;
          this.dropSentFromQueue(key, batch);
          const rest = queue.slice(QUEUE_BATCH);
          return rest.length ? this.sendQueueBatch(key, rest) : data;
        });
    },

    // Сервер подтверждает пачку числом обработанных кодов; неизвестные коды в
    // него входят, поэтому сойтись он обязан. Не сошлось — на сервере что-то
    // пошло не так: пачку не трогаем и повторим целиком, повтор пары code + ts
    // сервер вторым сканированием не считает.
    //
    // Поля нет вовсе — подтверждением считаем сам ответ 200, как делала прежняя
    // версия. Иначе очередь не очистится никогда и будет только расти.
    isBatchAccepted(data, size) {
      const all = Number(data?.results?.all);
      if (!Number.isFinite(all)) return true;
      return all === size;
    },

    readQueue(key) {
      try {
        const value = JSON.parse(localStorage.getItem(key));
        return Array.isArray(value) ? value : [];
      } catch (e) {
        return [];
      }
    },

    dropSentFromQueue(key, sent) {
      // Очередь могла пополниться, пока запрос был в пути: вычитаем ровно
      // отправленное, а не затираем ключ целиком.
      const sentIds = new Set(sent.map((item) => `${item.code}:${item.ts}`));
      const rest = this.readQueue(key).filter((item) => !sentIds.has(`${item.code}:${item.ts}`));
      try {
        localStorage.setItem(key, JSON.stringify(rest));
      } catch (e) {
        // Место кончилось на записи укоротившейся очереди — сообщать не о чем,
        // отправленное уже на сервере.
      }
    },
  },
};
